const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate joinBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const {
    separator = ', ',
    leftSource,
    rightSource
  } = source;
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values && values.length) {
    return values.join(separator);
  }
  const leftValue = await evaluateSource(leftSource, content, parentContentPath, transientContext, nativeFunctions);
  const rightValue = await evaluateSource(rightSource, content, parentContentPath, transientContext, nativeFunctions);
  if (leftValue !== undefined && rightValue !== undefined) {
    return [leftValue, rightValue].join(separator);
  }
  return undefined;
};
module.exports = {
  evaluate
};